import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=bd3d4c8e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3d4c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd3d4c8e')) {
      api.createRecord('bd3d4c8e', component.options)
    } else {
      api.reload('bd3d4c8e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=bd3d4c8e&scoped=true&", function () {
      api.rerender('bd3d4c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2i84b91DXDHi0/JS/comp/Accordion.vue"
export default component.exports